import React, { useState, useEffect } from 'react';
import { Box, Container, Grid, Typography, Stack, Link, Divider } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';

// Region configuration with phone numbers
const REGION_CONFIG = {
    Canada: {
        phone: '1 (866) 992-0240'
    },
    India: {
        phone: '+91 (888) 123-4567' // Update with actual Indian number
    }
};

const Footer = ({ region: propRegion }) => {
    const [region, setRegion] = useState(propRegion || "Canada");
    const SUPPORT_EMAIL = "support@miirapos.com";
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        // Use prop if provided, otherwise read from localStorage
        if (propRegion) {
            setRegion(propRegion);
        } else {
            const savedRegion = localStorage.getItem("api_region");
            if (savedRegion) {
                setRegion(savedRegion);
            }
        }
    }, [propRegion]);

    const PHONE_NUMBER = REGION_CONFIG[region]?.phone || REGION_CONFIG.Canada.phone;

    return (
        <Box component="footer" sx={{ background: '#0d1f38', color: '#fff', pt: 6, pb: 3, borderTop: '4px solid tomato' }}>
            <Container maxWidth="lg">
                <Grid container spacing={4} sx={{ mb: 4 }}>
                    
                    {/* Brand Profile Block */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h5" sx={{ fontWeight: 900, color: '#fff', mb: 2 }}>
                            MiiRA<span style={{ color: 'tomato' }}>POS</span>
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#dfe6e9', mb: 2, lineHeight: 1.6 }}>
                            The ultimate contract-free cloud point-of-sale ecosystem for scaling food concepts and specialized retail operations. Bring your own hardware and protect your profit margins.
                        </Typography>
                    </Grid>

                    {/* Clear Vertical Silos Selection Links */}
                    <Grid item xs={6} md={4}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'tomato', mb: 2, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Industry Solutions
                        </Typography>
                        <Stack spacing={1}>
                            <Link href="#contact" sx={{ color: '#dfe6e9', textDecoration: 'none', fontSize: '14px', '&:hover': { color: 'tomato' } }}>Fine Dining & Bars</Link>
                            <Link href="#contact" sx={{ color: '#dfe6e9', textDecoration: 'none', fontSize: '14px', '&:hover': { color: 'tomato' } }}>Pizzerias & Bakeries</Link>
                            <Link href="#contact" sx={{ color: '#dfe6e9', textDecoration: 'none', fontSize: '14px', '&:hover': { color: 'tomato' } }}>Fast Food & Food Courts</Link>
                            <Link href="#contact" sx={{ color: '#dfe6e9', textDecoration: 'none', fontSize: '14px', '&:hover': { color: 'tomato' } }}>Liquor Store Scale Systems</Link>
                            <Link href="#contact" sx={{ color: '#dfe6e9', textDecoration: 'none', fontSize: '14px', '&:hover': { color: 'tomato' } }}>Cannabis Retail</Link>
                        </Stack>
                    </Grid>

                    {/* Direct Maintenance Support Contact Matrix */}
                    <Grid item xs={6} md={4}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'tomato', mb: 2, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Maintenance & Support
                        </Typography>
                        <Stack spacing={2}>
                            <Typography variant="body2" sx={{ color: '#dfe6e9', display: 'flex', alignItems: 'center', gap: 1 }}>
                                <PhoneIcon fontSize="small" sx={{ color: 'tomato' }} /> Tel: {PHONE_NUMBER}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#dfe6e9', display: 'flex', alignItems: 'center', gap: 1 }}>
                                <MailIcon fontSize="small" sx={{ color: 'tomato' }} /> Email: {SUPPORT_EMAIL}
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#b2bec3', display: 'block', fontStyle: 'italic' }}>
                                Operated by MiiRA Corp.<br />
                                On-Site Network Signal & Hardware Diagnostics Available.
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>

                <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', my: 3 }} />

                {/* Subfooter Row */}
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" sx={{ color: '#b2bec3' }}>
                        &copy; {currentYear} MiiRA Corp. All Rights Reserved. MiiRA POS Ecosystem.
                    </Typography>
                    <Stack direction="row" spacing={3}>
                        <Link href="#home" sx={{ color: '#b2bec3', textDecoration: 'none', fontSize: '12px', '&:hover': { color: 'tomato' } }}>Privacy Policy</Link>
                        <Link href="/terms" sx={{ color: '#b2bec3', textDecoration: 'none', fontSize: '12px', '&:hover': { color: 'tomato' } }}>Terms of Service</Link>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
};

export default Footer;